const tokens = {
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--aspect-ratios-square)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--aspect-ratios-landscape)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--aspect-ratios-portrait)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--aspect-ratios-wide)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--aspect-ratios-ultrawide)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--aspect-ratios-golden)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-default)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--easings-linear)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--easings-in)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--easings-out)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-in-out)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--animations-ping)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--animations-pulse)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--animations-bounce)"
  },
  "animations.eds.duration.50": {
    "value": "50ms",
    "variable": "var(--animations-eds\\.duration\\.50)"
  },
  "animations.eds.duration.100": {
    "value": "100ms",
    "variable": "var(--animations-eds\\.duration\\.100)"
  },
  "animations.eds.duration.200": {
    "value": "200ms",
    "variable": "var(--animations-eds\\.duration\\.200)"
  },
  "animations.eds.duration.300": {
    "value": "300ms",
    "variable": "var(--animations-eds\\.duration\\.300)"
  },
  "animations.eds.duration.400": {
    "value": "400ms",
    "variable": "var(--animations-eds\\.duration\\.400)"
  },
  "animations.eds.duration.125": {
    "value": "125ms",
    "variable": "var(--animations-eds\\.duration\\.125)"
  },
  "animations.eds.duration.150": {
    "value": "150ms",
    "variable": "var(--animations-eds\\.duration\\.150)"
  },
  "animations.eds.duration.625": {
    "value": "625ms",
    "variable": "var(--animations-eds\\.duration\\.625)"
  },
  "animations.eds.duration.750": {
    "value": "750ms",
    "variable": "var(--animations-eds\\.duration\\.750)"
  },
  "animations.eds.duration.1000": {
    "value": "1000ms",
    "variable": "var(--animations-eds\\.duration\\.1000)"
  },
  "animations.eds.easing.linear": {
    "value": "cubic-bezier(0, 0, 1, 1)",
    "variable": "var(--animations-eds\\.easing\\.linear)"
  },
  "animations.eds.easing.easeInOutQuad": {
    "value": "cubic-bezier(0.45, 0, 0.55, 1)",
    "variable": "var(--animations-eds\\.easing\\.ease-in-out-quad)"
  },
  "animations.eds.easing.easeOutQuart": {
    "value": "cubic-bezier(0.25, 1, 0.5, 1)",
    "variable": "var(--animations-eds\\.easing\\.ease-out-quart)"
  },
  "animations.eds.easing.easeInOutMiddle": {
    "value": "cubic-bezier(0.87, 0, 0.13, 1)",
    "variable": "var(--animations-eds\\.easing\\.ease-in-out-middle)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000",
    "variable": "var(--colors-black)"
  },
  "colors.white": {
    "value": "#fff",
    "variable": "var(--colors-white)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--colors-transparent)"
  },
  "colors.rose.50": {
    "value": "#fff1f2",
    "variable": "var(--colors-rose-50)"
  },
  "colors.rose.100": {
    "value": "#ffe4e6",
    "variable": "var(--colors-rose-100)"
  },
  "colors.rose.200": {
    "value": "#fecdd3",
    "variable": "var(--colors-rose-200)"
  },
  "colors.rose.300": {
    "value": "#fda4af",
    "variable": "var(--colors-rose-300)"
  },
  "colors.rose.400": {
    "value": "#fb7185",
    "variable": "var(--colors-rose-400)"
  },
  "colors.rose.500": {
    "value": "#f43f5e",
    "variable": "var(--colors-rose-500)"
  },
  "colors.rose.600": {
    "value": "#e11d48",
    "variable": "var(--colors-rose-600)"
  },
  "colors.rose.700": {
    "value": "#be123c",
    "variable": "var(--colors-rose-700)"
  },
  "colors.rose.800": {
    "value": "#9f1239",
    "variable": "var(--colors-rose-800)"
  },
  "colors.rose.900": {
    "value": "#881337",
    "variable": "var(--colors-rose-900)"
  },
  "colors.rose.950": {
    "value": "#4c0519",
    "variable": "var(--colors-rose-950)"
  },
  "colors.pink.50": {
    "value": "#fdf2f8",
    "variable": "var(--colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#fce7f3",
    "variable": "var(--colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#fbcfe8",
    "variable": "var(--colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#f9a8d4",
    "variable": "var(--colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#f472b6",
    "variable": "var(--colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#ec4899",
    "variable": "var(--colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#db2777",
    "variable": "var(--colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#be185d",
    "variable": "var(--colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#9d174d",
    "variable": "var(--colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#831843",
    "variable": "var(--colors-pink-900)"
  },
  "colors.pink.950": {
    "value": "#500724",
    "variable": "var(--colors-pink-950)"
  },
  "colors.fuchsia.50": {
    "value": "#fdf4ff",
    "variable": "var(--colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    "value": "#fae8ff",
    "variable": "var(--colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    "value": "#f5d0fe",
    "variable": "var(--colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    "value": "#f0abfc",
    "variable": "var(--colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    "value": "#e879f9",
    "variable": "var(--colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    "value": "#d946ef",
    "variable": "var(--colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    "value": "#c026d3",
    "variable": "var(--colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    "value": "#a21caf",
    "variable": "var(--colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    "value": "#86198f",
    "variable": "var(--colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    "value": "#701a75",
    "variable": "var(--colors-fuchsia-900)"
  },
  "colors.fuchsia.950": {
    "value": "#4a044e",
    "variable": "var(--colors-fuchsia-950)"
  },
  "colors.purple.50": {
    "value": "#faf5ff",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#f3e8ff",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#e9d5ff",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#d8b4fe",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#c084fc",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#a855f7",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#9333ea",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#7e22ce",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#6b21a8",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#581c87",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#3b0764",
    "variable": "var(--colors-purple-950)"
  },
  "colors.violet.50": {
    "value": "#f5f3ff",
    "variable": "var(--colors-violet-50)"
  },
  "colors.violet.100": {
    "value": "#ede9fe",
    "variable": "var(--colors-violet-100)"
  },
  "colors.violet.200": {
    "value": "#ddd6fe",
    "variable": "var(--colors-violet-200)"
  },
  "colors.violet.300": {
    "value": "#c4b5fd",
    "variable": "var(--colors-violet-300)"
  },
  "colors.violet.400": {
    "value": "#a78bfa",
    "variable": "var(--colors-violet-400)"
  },
  "colors.violet.500": {
    "value": "#8b5cf6",
    "variable": "var(--colors-violet-500)"
  },
  "colors.violet.600": {
    "value": "#7c3aed",
    "variable": "var(--colors-violet-600)"
  },
  "colors.violet.700": {
    "value": "#6d28d9",
    "variable": "var(--colors-violet-700)"
  },
  "colors.violet.800": {
    "value": "#5b21b6",
    "variable": "var(--colors-violet-800)"
  },
  "colors.violet.900": {
    "value": "#4c1d95",
    "variable": "var(--colors-violet-900)"
  },
  "colors.violet.950": {
    "value": "#2e1065",
    "variable": "var(--colors-violet-950)"
  },
  "colors.indigo.50": {
    "value": "#eef2ff",
    "variable": "var(--colors-indigo-50)"
  },
  "colors.indigo.100": {
    "value": "#e0e7ff",
    "variable": "var(--colors-indigo-100)"
  },
  "colors.indigo.200": {
    "value": "#c7d2fe",
    "variable": "var(--colors-indigo-200)"
  },
  "colors.indigo.300": {
    "value": "#a5b4fc",
    "variable": "var(--colors-indigo-300)"
  },
  "colors.indigo.400": {
    "value": "#818cf8",
    "variable": "var(--colors-indigo-400)"
  },
  "colors.indigo.500": {
    "value": "#6366f1",
    "variable": "var(--colors-indigo-500)"
  },
  "colors.indigo.600": {
    "value": "#4f46e5",
    "variable": "var(--colors-indigo-600)"
  },
  "colors.indigo.700": {
    "value": "#4338ca",
    "variable": "var(--colors-indigo-700)"
  },
  "colors.indigo.800": {
    "value": "#3730a3",
    "variable": "var(--colors-indigo-800)"
  },
  "colors.indigo.900": {
    "value": "#312e81",
    "variable": "var(--colors-indigo-900)"
  },
  "colors.indigo.950": {
    "value": "#1e1b4b",
    "variable": "var(--colors-indigo-950)"
  },
  "colors.blue.50": {
    "value": "#eff6ff",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#dbeafe",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#bfdbfe",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#93c5fd",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#60a5fa",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#3b82f6",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#2563eb",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#1d4ed8",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#1e40af",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#1e3a8a",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#172554",
    "variable": "var(--colors-blue-950)"
  },
  "colors.sky.50": {
    "value": "#f0f9ff",
    "variable": "var(--colors-sky-50)"
  },
  "colors.sky.100": {
    "value": "#e0f2fe",
    "variable": "var(--colors-sky-100)"
  },
  "colors.sky.200": {
    "value": "#bae6fd",
    "variable": "var(--colors-sky-200)"
  },
  "colors.sky.300": {
    "value": "#7dd3fc",
    "variable": "var(--colors-sky-300)"
  },
  "colors.sky.400": {
    "value": "#38bdf8",
    "variable": "var(--colors-sky-400)"
  },
  "colors.sky.500": {
    "value": "#0ea5e9",
    "variable": "var(--colors-sky-500)"
  },
  "colors.sky.600": {
    "value": "#0284c7",
    "variable": "var(--colors-sky-600)"
  },
  "colors.sky.700": {
    "value": "#0369a1",
    "variable": "var(--colors-sky-700)"
  },
  "colors.sky.800": {
    "value": "#075985",
    "variable": "var(--colors-sky-800)"
  },
  "colors.sky.900": {
    "value": "#0c4a6e",
    "variable": "var(--colors-sky-900)"
  },
  "colors.sky.950": {
    "value": "#082f49",
    "variable": "var(--colors-sky-950)"
  },
  "colors.cyan.50": {
    "value": "#ecfeff",
    "variable": "var(--colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#cffafe",
    "variable": "var(--colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "#a5f3fc",
    "variable": "var(--colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "#67e8f9",
    "variable": "var(--colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "#22d3ee",
    "variable": "var(--colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "#06b6d4",
    "variable": "var(--colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "#0891b2",
    "variable": "var(--colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "#0e7490",
    "variable": "var(--colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "#155e75",
    "variable": "var(--colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "#164e63",
    "variable": "var(--colors-cyan-900)"
  },
  "colors.cyan.950": {
    "value": "#083344",
    "variable": "var(--colors-cyan-950)"
  },
  "colors.teal.50": {
    "value": "#f0fdfa",
    "variable": "var(--colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "#ccfbf1",
    "variable": "var(--colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "#99f6e4",
    "variable": "var(--colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "#5eead4",
    "variable": "var(--colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "#2dd4bf",
    "variable": "var(--colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "#14b8a6",
    "variable": "var(--colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "#0d9488",
    "variable": "var(--colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "#0f766e",
    "variable": "var(--colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "#115e59",
    "variable": "var(--colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "#134e4a",
    "variable": "var(--colors-teal-900)"
  },
  "colors.teal.950": {
    "value": "#042f2e",
    "variable": "var(--colors-teal-950)"
  },
  "colors.emerald.50": {
    "value": "#ecfdf5",
    "variable": "var(--colors-emerald-50)"
  },
  "colors.emerald.100": {
    "value": "#d1fae5",
    "variable": "var(--colors-emerald-100)"
  },
  "colors.emerald.200": {
    "value": "#a7f3d0",
    "variable": "var(--colors-emerald-200)"
  },
  "colors.emerald.300": {
    "value": "#6ee7b7",
    "variable": "var(--colors-emerald-300)"
  },
  "colors.emerald.400": {
    "value": "#34d399",
    "variable": "var(--colors-emerald-400)"
  },
  "colors.emerald.500": {
    "value": "#10b981",
    "variable": "var(--colors-emerald-500)"
  },
  "colors.emerald.600": {
    "value": "#059669",
    "variable": "var(--colors-emerald-600)"
  },
  "colors.emerald.700": {
    "value": "#047857",
    "variable": "var(--colors-emerald-700)"
  },
  "colors.emerald.800": {
    "value": "#065f46",
    "variable": "var(--colors-emerald-800)"
  },
  "colors.emerald.900": {
    "value": "#064e3b",
    "variable": "var(--colors-emerald-900)"
  },
  "colors.emerald.950": {
    "value": "#022c22",
    "variable": "var(--colors-emerald-950)"
  },
  "colors.green.50": {
    "value": "#f0fdf4",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#dcfce7",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "#bbf7d0",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "#86efac",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "#4ade80",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "#22c55e",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "#16a34a",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "#15803d",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "#166534",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "#14532d",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "#052e16",
    "variable": "var(--colors-green-950)"
  },
  "colors.lime.50": {
    "value": "#f7fee7",
    "variable": "var(--colors-lime-50)"
  },
  "colors.lime.100": {
    "value": "#ecfccb",
    "variable": "var(--colors-lime-100)"
  },
  "colors.lime.200": {
    "value": "#d9f99d",
    "variable": "var(--colors-lime-200)"
  },
  "colors.lime.300": {
    "value": "#bef264",
    "variable": "var(--colors-lime-300)"
  },
  "colors.lime.400": {
    "value": "#a3e635",
    "variable": "var(--colors-lime-400)"
  },
  "colors.lime.500": {
    "value": "#84cc16",
    "variable": "var(--colors-lime-500)"
  },
  "colors.lime.600": {
    "value": "#65a30d",
    "variable": "var(--colors-lime-600)"
  },
  "colors.lime.700": {
    "value": "#4d7c0f",
    "variable": "var(--colors-lime-700)"
  },
  "colors.lime.800": {
    "value": "#3f6212",
    "variable": "var(--colors-lime-800)"
  },
  "colors.lime.900": {
    "value": "#365314",
    "variable": "var(--colors-lime-900)"
  },
  "colors.lime.950": {
    "value": "#1a2e05",
    "variable": "var(--colors-lime-950)"
  },
  "colors.yellow.50": {
    "value": "#fefce8",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#fef9c3",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#fef08a",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#fde047",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#facc15",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#eab308",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#ca8a04",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#a16207",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#854d0e",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#713f12",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#422006",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.amber.50": {
    "value": "#fffbeb",
    "variable": "var(--colors-amber-50)"
  },
  "colors.amber.100": {
    "value": "#fef3c7",
    "variable": "var(--colors-amber-100)"
  },
  "colors.amber.200": {
    "value": "#fde68a",
    "variable": "var(--colors-amber-200)"
  },
  "colors.amber.300": {
    "value": "#fcd34d",
    "variable": "var(--colors-amber-300)"
  },
  "colors.amber.400": {
    "value": "#fbbf24",
    "variable": "var(--colors-amber-400)"
  },
  "colors.amber.500": {
    "value": "#f59e0b",
    "variable": "var(--colors-amber-500)"
  },
  "colors.amber.600": {
    "value": "#d97706",
    "variable": "var(--colors-amber-600)"
  },
  "colors.amber.700": {
    "value": "#b45309",
    "variable": "var(--colors-amber-700)"
  },
  "colors.amber.800": {
    "value": "#92400e",
    "variable": "var(--colors-amber-800)"
  },
  "colors.amber.900": {
    "value": "#78350f",
    "variable": "var(--colors-amber-900)"
  },
  "colors.amber.950": {
    "value": "#451a03",
    "variable": "var(--colors-amber-950)"
  },
  "colors.orange.50": {
    "value": "#fff7ed",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#ffedd5",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "#fed7aa",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "#fdba74",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "#fb923c",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "#f97316",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "#ea580c",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "#c2410c",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "#9a3412",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "#7c2d12",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "#431407",
    "variable": "var(--colors-orange-950)"
  },
  "colors.red.50": {
    "value": "#fef2f2",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#fee2e2",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "#fecaca",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "#fca5a5",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "#f87171",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "#ef4444",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "#dc2626",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "#b91c1c",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "#991b1b",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "#7f1d1d",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "#450a0a",
    "variable": "var(--colors-red-950)"
  },
  "colors.neutral.50": {
    "value": "#fafafa",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "#f5f5f5",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "#e5e5e5",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "#d4d4d4",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "#a3a3a3",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "#737373",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "#525252",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "#404040",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "#262626",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "#171717",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "#0a0a0a",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.stone.50": {
    "value": "#fafaf9",
    "variable": "var(--colors-stone-50)"
  },
  "colors.stone.100": {
    "value": "#f5f5f4",
    "variable": "var(--colors-stone-100)"
  },
  "colors.stone.200": {
    "value": "#e7e5e4",
    "variable": "var(--colors-stone-200)"
  },
  "colors.stone.300": {
    "value": "#d6d3d1",
    "variable": "var(--colors-stone-300)"
  },
  "colors.stone.400": {
    "value": "#a8a29e",
    "variable": "var(--colors-stone-400)"
  },
  "colors.stone.500": {
    "value": "#78716c",
    "variable": "var(--colors-stone-500)"
  },
  "colors.stone.600": {
    "value": "#57534e",
    "variable": "var(--colors-stone-600)"
  },
  "colors.stone.700": {
    "value": "#44403c",
    "variable": "var(--colors-stone-700)"
  },
  "colors.stone.800": {
    "value": "#292524",
    "variable": "var(--colors-stone-800)"
  },
  "colors.stone.900": {
    "value": "#1c1917",
    "variable": "var(--colors-stone-900)"
  },
  "colors.stone.950": {
    "value": "#0c0a09",
    "variable": "var(--colors-stone-950)"
  },
  "colors.zinc.50": {
    "value": "#fafafa",
    "variable": "var(--colors-zinc-50)"
  },
  "colors.zinc.100": {
    "value": "#f4f4f5",
    "variable": "var(--colors-zinc-100)"
  },
  "colors.zinc.200": {
    "value": "#e4e4e7",
    "variable": "var(--colors-zinc-200)"
  },
  "colors.zinc.300": {
    "value": "#d4d4d8",
    "variable": "var(--colors-zinc-300)"
  },
  "colors.zinc.400": {
    "value": "#a1a1aa",
    "variable": "var(--colors-zinc-400)"
  },
  "colors.zinc.500": {
    "value": "#71717a",
    "variable": "var(--colors-zinc-500)"
  },
  "colors.zinc.600": {
    "value": "#52525b",
    "variable": "var(--colors-zinc-600)"
  },
  "colors.zinc.700": {
    "value": "#3f3f46",
    "variable": "var(--colors-zinc-700)"
  },
  "colors.zinc.800": {
    "value": "#27272a",
    "variable": "var(--colors-zinc-800)"
  },
  "colors.zinc.900": {
    "value": "#18181b",
    "variable": "var(--colors-zinc-900)"
  },
  "colors.zinc.950": {
    "value": "#09090b",
    "variable": "var(--colors-zinc-950)"
  },
  "colors.gray.50": {
    "value": "#f9fafb",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "#f3f4f6",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "#e5e7eb",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "#d1d5db",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.400": {
    "value": "#9ca3af",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "#6b7280",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "#4b5563",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#374151",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "#1f2937",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "#111827",
    "variable": "var(--colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "#030712",
    "variable": "var(--colors-gray-950)"
  },
  "colors.slate.50": {
    "value": "#f8fafc",
    "variable": "var(--colors-slate-50)"
  },
  "colors.slate.100": {
    "value": "#f1f5f9",
    "variable": "var(--colors-slate-100)"
  },
  "colors.slate.200": {
    "value": "#e2e8f0",
    "variable": "var(--colors-slate-200)"
  },
  "colors.slate.300": {
    "value": "#cbd5e1",
    "variable": "var(--colors-slate-300)"
  },
  "colors.slate.400": {
    "value": "#94a3b8",
    "variable": "var(--colors-slate-400)"
  },
  "colors.slate.500": {
    "value": "#64748b",
    "variable": "var(--colors-slate-500)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--colors-slate-600)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--colors-slate-700)"
  },
  "colors.slate.800": {
    "value": "#1e293b",
    "variable": "var(--colors-slate-800)"
  },
  "colors.slate.900": {
    "value": "#0f172a",
    "variable": "var(--colors-slate-900)"
  },
  "colors.slate.950": {
    "value": "#020617",
    "variable": "var(--colors-slate-950)"
  },
  "colors.eds.background.backdrop.strong": {
    "value": "rgba(0, 0, 0, 0.65)",
    "variable": "var(--colors-eds\\.background\\.backdrop\\.strong)"
  },
  "colors.eds.background.backdrop.regular": {
    "value": "rgba(0, 0, 0, 0.35)",
    "variable": "var(--colors-eds\\.background\\.backdrop\\.regular)"
  },
  "colors.eds.background.menu": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.background\\.menu)"
  },
  "colors.eds.background.default": {
    "value": "#101014",
    "variable": "var(--colors-eds\\.background\\.default)"
  },
  "colors.eds.background.elevated.low.default": {
    "value": "#18181c",
    "variable": "var(--colors-eds\\.background\\.elevated\\.low\\.default)"
  },
  "colors.eds.background.elevated.low.transparent": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-eds\\.background\\.elevated\\.low\\.transparent)"
  },
  "colors.eds.background.elevated.high.default": {
    "value": "#202024",
    "variable": "var(--colors-eds\\.background\\.elevated\\.high\\.default)"
  },
  "colors.eds.background.elevated.high.hover": {
    "value": "#404044",
    "variable": "var(--colors-eds\\.background\\.elevated\\.high\\.hover)"
  },
  "colors.eds.background.elevated.high.press": {
    "value": "#202024",
    "variable": "var(--colors-eds\\.background\\.elevated\\.high\\.press)"
  },
  "colors.eds.background.elevated.high.select": {
    "value": "#28282c",
    "variable": "var(--colors-eds\\.background\\.elevated\\.high\\.select)"
  },
  "colors.eds.border.focus": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.border\\.focus)"
  },
  "colors.eds.border.disabled": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.border\\.disabled)"
  },
  "colors.eds.border.accent.default": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.border\\.accent\\.default)"
  },
  "colors.eds.border.accent.hover": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.border\\.accent\\.hover)"
  },
  "colors.eds.border.subtle": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.border\\.subtle)"
  },
  "colors.eds.border.critical.default": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.border\\.critical\\.default)"
  },
  "colors.eds.border.critical.hover": {
    "value": "#ff8291",
    "variable": "var(--colors-eds\\.border\\.critical\\.hover)"
  },
  "colors.eds.border.critical.press": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.border\\.critical\\.press)"
  },
  "colors.eds.border.default": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.border\\.default)"
  },
  "colors.eds.border.hover": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.border\\.hover)"
  },
  "colors.eds.border.press": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.border\\.press)"
  },
  "colors.eds.border.subdued": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--colors-eds\\.border\\.subdued)"
  },
  "colors.eds.border.faint": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-eds\\.border\\.faint)"
  },
  "colors.eds.fill.primary.default": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.fill\\.primary\\.default)"
  },
  "colors.eds.fill.primary.hover": {
    "value": "#72d3ff",
    "variable": "var(--colors-eds\\.fill\\.primary\\.hover)"
  },
  "colors.eds.fill.primary.press": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.fill\\.primary\\.press)"
  },
  "colors.eds.fill.primary.disabled": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.fill\\.primary\\.disabled)"
  },
  "colors.eds.fill.contrast.default": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.fill\\.contrast\\.default)"
  },
  "colors.eds.fill.contrast.hover": {
    "value": "#a6a6a6",
    "variable": "var(--colors-eds\\.fill\\.contrast\\.hover)"
  },
  "colors.eds.fill.contrast.press": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.fill\\.contrast\\.press)"
  },
  "colors.eds.fill.secondary.elevated.default": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.elevated\\.default)"
  },
  "colors.eds.fill.secondary.elevated.hover": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.elevated\\.hover)"
  },
  "colors.eds.fill.secondary.default": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.default)"
  },
  "colors.eds.fill.secondary.hover": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.hover)"
  },
  "colors.eds.fill.secondary.press": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.press)"
  },
  "colors.eds.fill.secondary.disabled": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.disabled)"
  },
  "colors.eds.fill.secondary.recessed": {
    "value": "#101014",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.recessed)"
  },
  "colors.eds.fill.secondary.subdued": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.fill\\.secondary\\.subdued)"
  },
  "colors.eds.fill.tertiary.default": {
    "value": "rgba(0, 0, 0, 0)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.default)"
  },
  "colors.eds.fill.tertiary.hover": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.hover)"
  },
  "colors.eds.fill.tertiary.elevated.hover": {
    "value": "#505054",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.elevated\\.hover)"
  },
  "colors.eds.fill.tertiary.select.default": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.select\\.default)"
  },
  "colors.eds.fill.tertiary.select.hover": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.select\\.hover)"
  },
  "colors.eds.fill.tertiary.select.press": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.select\\.press)"
  },
  "colors.eds.fill.tertiary.press": {
    "value": "rgba(0, 0, 0, 0)",
    "variable": "var(--colors-eds\\.fill\\.tertiary\\.press)"
  },
  "colors.eds.fill.input.disabled": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.fill\\.input\\.disabled)"
  },
  "colors.eds.fill.input.default": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-eds\\.fill\\.input\\.default)"
  },
  "colors.eds.fill.success.default": {
    "value": "#45c761",
    "variable": "var(--colors-eds\\.fill\\.success\\.default)"
  },
  "colors.eds.fill.success.alternate": {
    "value": "#71d687",
    "variable": "var(--colors-eds\\.fill\\.success\\.alternate)"
  },
  "colors.eds.fill.informational": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.fill\\.informational)"
  },
  "colors.eds.fill.warning.default": {
    "value": "#ffc229",
    "variable": "var(--colors-eds\\.fill\\.warning\\.default)"
  },
  "colors.eds.fill.warning.alternate": {
    "value": "#ffd15c",
    "variable": "var(--colors-eds\\.fill\\.warning\\.alternate)"
  },
  "colors.eds.fill.critical.default": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.fill\\.critical\\.default)"
  },
  "colors.eds.fill.critical.alternate": {
    "value": "#ff6173",
    "variable": "var(--colors-eds\\.fill\\.critical\\.alternate)"
  },
  "colors.eds.fill.critical.hover": {
    "value": "#ff8291",
    "variable": "var(--colors-eds\\.fill\\.critical\\.hover)"
  },
  "colors.eds.fill.critical.press": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.fill\\.critical\\.press)"
  },
  "colors.eds.fill.disabled.primary": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.fill\\.disabled\\.primary)"
  },
  "colors.eds.fill.disabled.secondary": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.fill\\.disabled\\.secondary)"
  },
  "colors.eds.fill.disabled.tertiary": {
    "value": "rgba(0, 0, 0, 0)",
    "variable": "var(--colors-eds\\.fill\\.disabled\\.tertiary)"
  },
  "colors.eds.icon.primary": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.icon\\.primary)"
  },
  "colors.eds.icon.secondary": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.icon\\.secondary)"
  },
  "colors.eds.icon.disabled.default": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.icon\\.disabled\\.default)"
  },
  "colors.eds.icon.disabled.inverted": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.icon\\.disabled\\.inverted)"
  },
  "colors.eds.icon.link.primary.default": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.icon\\.link\\.primary\\.default)"
  },
  "colors.eds.icon.link.primary.press": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.icon\\.link\\.primary\\.press)"
  },
  "colors.eds.icon.link.secondary.default": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.icon\\.link\\.secondary\\.default)"
  },
  "colors.eds.icon.link.secondary.press": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.icon\\.link\\.secondary\\.press)"
  },
  "colors.eds.icon.select.default": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.icon\\.select\\.default)"
  },
  "colors.eds.icon.select.hover": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.icon\\.select\\.hover)"
  },
  "colors.eds.icon.informational": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.icon\\.informational)"
  },
  "colors.eds.icon.success": {
    "value": "#45c761",
    "variable": "var(--colors-eds\\.icon\\.success)"
  },
  "colors.eds.icon.warning": {
    "value": "#ffc229",
    "variable": "var(--colors-eds\\.icon\\.warning)"
  },
  "colors.eds.icon.critical": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.icon\\.critical)"
  },
  "colors.eds.icon.onAccent": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.icon\\.on-accent)"
  },
  "colors.eds.icon.contrast": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.icon\\.contrast)"
  },
  "colors.eds.material.100": {
    "value": "rgba(16, 16, 20, 0.85)",
    "variable": "var(--colors-eds\\.material\\.100)"
  },
  "colors.eds.material.200": {
    "value": "rgba(32, 32, 36, 0.7)",
    "variable": "var(--colors-eds\\.material\\.200)"
  },
  "colors.eds.material.300": {
    "value": "rgba(48, 48, 52, 0.7)",
    "variable": "var(--colors-eds\\.material\\.300)"
  },
  "colors.eds.material.default.strong": {
    "value": "rgba(16, 16, 20, 0.7)",
    "variable": "var(--colors-eds\\.material\\.default\\.strong)"
  },
  "colors.eds.material.default.weak": {
    "value": "rgba(16, 16, 20, 0.4)",
    "variable": "var(--colors-eds\\.material\\.default\\.weak)"
  },
  "colors.eds.material.elevated.high.strong": {
    "value": "rgba(48, 48, 52, 0.7)",
    "variable": "var(--colors-eds\\.material\\.elevated\\.high\\.strong)"
  },
  "colors.eds.material.elevated.high.weak": {
    "value": "rgba(48, 48, 52, 0.4)",
    "variable": "var(--colors-eds\\.material\\.elevated\\.high\\.weak)"
  },
  "colors.eds.material.elevated.low.strong": {
    "value": "rgba(32, 32, 36, 0.7)",
    "variable": "var(--colors-eds\\.material\\.elevated\\.low\\.strong)"
  },
  "colors.eds.material.elevated.low.weak": {
    "value": "rgba(32, 32, 36, 0.4)",
    "variable": "var(--colors-eds\\.material\\.elevated\\.low\\.weak)"
  },
  "colors.eds.neutral.100": {
    "value": "#101014",
    "variable": "var(--colors-eds\\.neutral\\.100)"
  },
  "colors.eds.neutral.150": {
    "value": "#18181c",
    "variable": "var(--colors-eds\\.neutral\\.150)"
  },
  "colors.eds.neutral.200": {
    "value": "#202024",
    "variable": "var(--colors-eds\\.neutral\\.200)"
  },
  "colors.eds.neutral.250": {
    "value": "#28282c",
    "variable": "var(--colors-eds\\.neutral\\.250)"
  },
  "colors.eds.neutral.300": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.neutral\\.300)"
  },
  "colors.eds.palette.static.white": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.palette\\.static\\.white)"
  },
  "colors.eds.palette.static.black": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.palette\\.static\\.black)"
  },
  "colors.eds.palette.grayscale.gray010": {
    "value": "#101014",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray010)"
  },
  "colors.eds.palette.grayscale.gray020": {
    "value": "#18181c",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray020)"
  },
  "colors.eds.palette.grayscale.gray030": {
    "value": "#202024",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray030)"
  },
  "colors.eds.palette.grayscale.gray040": {
    "value": "#28282c",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray040)"
  },
  "colors.eds.palette.grayscale.gray050": {
    "value": "#303034",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray050)"
  },
  "colors.eds.palette.grayscale.gray060": {
    "value": "#404044",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray060)"
  },
  "colors.eds.palette.grayscale.gray070": {
    "value": "#505054",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray070)"
  },
  "colors.eds.palette.grayscale.gray080": {
    "value": "#606064",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray080)"
  },
  "colors.eds.palette.grayscale.gray090": {
    "value": "#707074",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray090)"
  },
  "colors.eds.palette.grayscale.gray100": {
    "value": "#808084",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray100)"
  },
  "colors.eds.palette.grayscale.gray110": {
    "value": "#aaaaae",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray110)"
  },
  "colors.eds.palette.grayscale.gray120": {
    "value": "#e6e6ea",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.gray120)"
  },
  "colors.eds.palette.grayscale.transparent": {
    "value": "rgba(0, 0, 0, 0)",
    "variable": "var(--colors-eds\\.palette\\.grayscale\\.transparent)"
  },
  "colors.eds.palette.accent.blue200": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.palette\\.accent\\.blue200)"
  },
  "colors.eds.palette.accent.lime200": {
    "value": "#a9d34f",
    "variable": "var(--colors-eds\\.palette\\.accent\\.lime200)"
  },
  "colors.eds.palette.accent.yellow200": {
    "value": "#ffc229",
    "variable": "var(--colors-eds\\.palette\\.accent\\.yellow200)"
  },
  "colors.eds.palette.accent.red200": {
    "value": "#ff3f56",
    "variable": "var(--colors-eds\\.palette\\.accent\\.red200)"
  },
  "colors.eds.palette.accent.pink200": {
    "value": "#fe54ba",
    "variable": "var(--colors-eds\\.palette\\.accent\\.pink200)"
  },
  "colors.eds.palette.accent.purple200": {
    "value": "#be3dff",
    "variable": "var(--colors-eds\\.palette\\.accent\\.purple200)"
  },
  "colors.eds.palette.accent.indigo200": {
    "value": "#7371ff",
    "variable": "var(--colors-eds\\.palette\\.accent\\.indigo200)"
  },
  "colors.eds.palette.accent.cyan200": {
    "value": "#43dac2",
    "variable": "var(--colors-eds\\.palette\\.accent\\.cyan200)"
  },
  "colors.eds.palette.accent.green200": {
    "value": "#45c761",
    "variable": "var(--colors-eds\\.palette\\.accent\\.green200)"
  },
  "colors.eds.palette.accent.amber200": {
    "value": "#ff8e1f",
    "variable": "var(--colors-eds\\.palette\\.accent\\.amber200)"
  },
  "colors.eds.palette.accent.orange200": {
    "value": "#fd6535",
    "variable": "var(--colors-eds\\.palette\\.accent\\.orange200)"
  },
  "colors.eds.palette.accent.brown200": {
    "value": "#b2715d",
    "variable": "var(--colors-eds\\.palette\\.accent\\.brown200)"
  },
  "colors.eds.palette.accentTone.blue300": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.blue300)"
  },
  "colors.eds.palette.accentTone.blue400": {
    "value": "#72d3ff",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.blue400)"
  },
  "colors.eds.palette.accentTone.lime300": {
    "value": "#bfde7c",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.lime300)"
  },
  "colors.eds.palette.accentTone.yellow300": {
    "value": "#ffd15c",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.yellow300)"
  },
  "colors.eds.palette.accentTone.red300": {
    "value": "#ff6173",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.red300)"
  },
  "colors.eds.palette.accentTone.red400": {
    "value": "#ff8291",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.red400)"
  },
  "colors.eds.palette.accentTone.pink300": {
    "value": "#fe71c6",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.pink300)"
  },
  "colors.eds.palette.accentTone.purple300": {
    "value": "#d480ff",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.purple300)"
  },
  "colors.eds.palette.accentTone.indigo300": {
    "value": "#aaa8ff",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.indigo300)"
  },
  "colors.eds.palette.accentTone.cyan300": {
    "value": "#88e7d7",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.cyan300)"
  },
  "colors.eds.palette.accentTone.green300": {
    "value": "#71d687",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.green300)"
  },
  "colors.eds.palette.accentTone.amber300": {
    "value": "#ffb061",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.amber300)"
  },
  "colors.eds.palette.accentTone.orange300": {
    "value": "#fd7b53",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.orange300)"
  },
  "colors.eds.palette.accentTone.brown300": {
    "value": "#c89889",
    "variable": "var(--colors-eds\\.palette\\.accent-tone\\.brown300)"
  },
  "colors.eds.palette.transparent.light.005": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.005)"
  },
  "colors.eds.palette.transparent.light.010": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.010)"
  },
  "colors.eds.palette.transparent.light.015": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.015)"
  },
  "colors.eds.palette.transparent.light.035": {
    "value": "rgba(255, 255, 255, 0.35)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.035)"
  },
  "colors.eds.palette.transparent.light.065": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.065)"
  },
  "colors.eds.palette.transparent.light.100": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.light\\.100)"
  },
  "colors.eds.palette.transparent.dark.005": {
    "value": "rgba(0, 0, 0, 0.05)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.005)"
  },
  "colors.eds.palette.transparent.dark.010": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.010)"
  },
  "colors.eds.palette.transparent.dark.015": {
    "value": "rgba(0, 0, 0, 0.15)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.015)"
  },
  "colors.eds.palette.transparent.dark.035": {
    "value": "rgba(0, 0, 0, 0.35)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.035)"
  },
  "colors.eds.palette.transparent.dark.065": {
    "value": "rgba(0, 0, 0, 0.65)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.065)"
  },
  "colors.eds.palette.transparent.dark.100": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.dark\\.100)"
  },
  "colors.eds.palette.transparent.elevated.high.hover": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-eds\\.palette\\.transparent\\.elevated\\.high\\.hover)"
  },
  "colors.eds.palette.red.100": {
    "value": "#331313",
    "variable": "var(--colors-eds\\.palette\\.red\\.100)"
  },
  "colors.eds.palette.red.200": {
    "value": "#762c2c",
    "variable": "var(--colors-eds\\.palette\\.red\\.200)"
  },
  "colors.eds.palette.red.300": {
    "value": "#ba4545",
    "variable": "var(--colors-eds\\.palette\\.red\\.300)"
  },
  "colors.eds.palette.red.400": {
    "value": "#fd5e5e",
    "variable": "var(--colors-eds\\.palette\\.red\\.400)"
  },
  "colors.eds.palette.red.500": {
    "value": "#fe8989",
    "variable": "var(--colors-eds\\.palette\\.red\\.500)"
  },
  "colors.eds.palette.red.600": {
    "value": "#feb4b4",
    "variable": "var(--colors-eds\\.palette\\.red\\.600)"
  },
  "colors.eds.palette.red.700": {
    "value": "#ffdfdf",
    "variable": "var(--colors-eds\\.palette\\.red\\.700)"
  },
  "colors.eds.palette.pink.100": {
    "value": "#2d1424",
    "variable": "var(--colors-eds\\.palette\\.pink\\.100)"
  },
  "colors.eds.palette.pink.200": {
    "value": "#693055",
    "variable": "var(--colors-eds\\.palette\\.pink\\.200)"
  },
  "colors.eds.palette.pink.300": {
    "value": "#a54b85",
    "variable": "var(--colors-eds\\.palette\\.pink\\.300)"
  },
  "colors.eds.palette.pink.400": {
    "value": "#e166b6",
    "variable": "var(--colors-eds\\.palette\\.pink\\.400)"
  },
  "colors.eds.palette.pink.500": {
    "value": "#e98fc9",
    "variable": "var(--colors-eds\\.palette\\.pink\\.500)"
  },
  "colors.eds.palette.pink.600": {
    "value": "#f1b8dd",
    "variable": "var(--colors-eds\\.palette\\.pink\\.600)"
  },
  "colors.eds.palette.pink.700": {
    "value": "#f9e0f0",
    "variable": "var(--colors-eds\\.palette\\.pink\\.700)"
  },
  "colors.eds.palette.purple.100": {
    "value": "#251530",
    "variable": "var(--colors-eds\\.palette\\.purple\\.100)"
  },
  "colors.eds.palette.purple.200": {
    "value": "#573270",
    "variable": "var(--colors-eds\\.palette\\.purple\\.200)"
  },
  "colors.eds.palette.purple.300": {
    "value": "#894eb0",
    "variable": "var(--colors-eds\\.palette\\.purple\\.300)"
  },
  "colors.eds.palette.purple.400": {
    "value": "#bb6bf0",
    "variable": "var(--colors-eds\\.palette\\.purple\\.400)"
  },
  "colors.eds.palette.purple.500": {
    "value": "#cd92f4",
    "variable": "var(--colors-eds\\.palette\\.purple\\.500)"
  },
  "colors.eds.palette.purple.600": {
    "value": "#dfbaf8",
    "variable": "var(--colors-eds\\.palette\\.purple\\.600)"
  },
  "colors.eds.palette.purple.700": {
    "value": "#f1e1fc",
    "variable": "var(--colors-eds\\.palette\\.purple\\.700)"
  },
  "colors.eds.palette.indigo.100": {
    "value": "#1b1c33",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.100)"
  },
  "colors.eds.palette.indigo.200": {
    "value": "#3f4076",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.200)"
  },
  "colors.eds.palette.indigo.300": {
    "value": "#6265ba",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.300)"
  },
  "colors.eds.palette.indigo.400": {
    "value": "#868afd",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.400)"
  },
  "colors.eds.palette.indigo.500": {
    "value": "#a6a9fe",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.500)"
  },
  "colors.eds.palette.indigo.600": {
    "value": "#c7c8fe",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.600)"
  },
  "colors.eds.palette.indigo.700": {
    "value": "#e7e8ff",
    "variable": "var(--colors-eds\\.palette\\.indigo\\.700)"
  },
  "colors.eds.palette.blue.100": {
    "value": "#0a2633",
    "variable": "var(--colors-eds\\.palette\\.blue\\.100)"
  },
  "colors.eds.palette.blue.200": {
    "value": "#185977",
    "variable": "var(--colors-eds\\.palette\\.blue\\.200)"
  },
  "colors.eds.palette.blue.300": {
    "value": "#258cbb",
    "variable": "var(--colors-eds\\.palette\\.blue\\.300)"
  },
  "colors.eds.palette.blue.400": {
    "value": "#33bfff",
    "variable": "var(--colors-eds\\.palette\\.blue\\.400)"
  },
  "colors.eds.palette.blue.500": {
    "value": "#69d0ff",
    "variable": "var(--colors-eds\\.palette\\.blue\\.500)"
  },
  "colors.eds.palette.blue.600": {
    "value": "#a0e1ff",
    "variable": "var(--colors-eds\\.palette\\.blue\\.600)"
  },
  "colors.eds.palette.blue.700": {
    "value": "#d6f2ff",
    "variable": "var(--colors-eds\\.palette\\.blue\\.700)"
  },
  "colors.eds.palette.cyan.100": {
    "value": "#0e2b26",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.100)"
  },
  "colors.eds.palette.cyan.200": {
    "value": "#206359",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.200)"
  },
  "colors.eds.palette.cyan.300": {
    "value": "#329c8c",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.300)"
  },
  "colors.eds.palette.cyan.400": {
    "value": "#44d5bf",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.400)"
  },
  "colors.eds.palette.cyan.500": {
    "value": "#76e0d0",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.500)"
  },
  "colors.eds.palette.cyan.600": {
    "value": "#a8ebe1",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.600)"
  },
  "colors.eds.palette.cyan.700": {
    "value": "#daf7f2",
    "variable": "var(--colors-eds\\.palette\\.cyan\\.700)"
  },
  "colors.eds.palette.green.100": {
    "value": "#132d15",
    "variable": "var(--colors-eds\\.palette\\.green\\.100)"
  },
  "colors.eds.palette.green.200": {
    "value": "#2c6a30",
    "variable": "var(--colors-eds\\.palette\\.green\\.200)"
  },
  "colors.eds.palette.green.300": {
    "value": "#46a64c",
    "variable": "var(--colors-eds\\.palette\\.green\\.300)"
  },
  "colors.eds.palette.green.400": {
    "value": "#5fe367",
    "variable": "var(--colors-eds\\.palette\\.green\\.400)"
  },
  "colors.eds.palette.green.500": {
    "value": "#8aea90",
    "variable": "var(--colors-eds\\.palette\\.green\\.500)"
  },
  "colors.eds.palette.green.600": {
    "value": "#b4f2b8",
    "variable": "var(--colors-eds\\.palette\\.green\\.600)"
  },
  "colors.eds.palette.green.700": {
    "value": "#dff9e1",
    "variable": "var(--colors-eds\\.palette\\.green\\.700)"
  },
  "colors.eds.palette.lime.100": {
    "value": "#222e11",
    "variable": "var(--colors-eds\\.palette\\.lime\\.100)"
  },
  "colors.eds.palette.lime.200": {
    "value": "#4f6c28",
    "variable": "var(--colors-eds\\.palette\\.lime\\.200)"
  },
  "colors.eds.palette.lime.300": {
    "value": "#7da93e",
    "variable": "var(--colors-eds\\.palette\\.lime\\.300)"
  },
  "colors.eds.palette.lime.400": {
    "value": "#aae755",
    "variable": "var(--colors-eds\\.palette\\.lime\\.400)"
  },
  "colors.eds.palette.lime.500": {
    "value": "#c1ed82",
    "variable": "var(--colors-eds\\.palette\\.lime\\.500)"
  },
  "colors.eds.palette.lime.600": {
    "value": "#d7f4b0",
    "variable": "var(--colors-eds\\.palette\\.lime\\.600)"
  },
  "colors.eds.palette.lime.700": {
    "value": "#eefadd",
    "variable": "var(--colors-eds\\.palette\\.lime\\.700)"
  },
  "colors.eds.palette.yellow.100": {
    "value": "#312b09",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.100)"
  },
  "colors.eds.palette.yellow.200": {
    "value": "#736514",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.200)"
  },
  "colors.eds.palette.yellow.300": {
    "value": "#b59e20",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.300)"
  },
  "colors.eds.palette.yellow.400": {
    "value": "#f7d82b",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.400)"
  },
  "colors.eds.palette.yellow.500": {
    "value": "#f9e264",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.500)"
  },
  "colors.eds.palette.yellow.600": {
    "value": "#fbed9c",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.600)"
  },
  "colors.eds.palette.yellow.700": {
    "value": "#fdf7d5",
    "variable": "var(--colors-eds\\.palette\\.yellow\\.700)"
  },
  "colors.eds.palette.amber.100": {
    "value": "#322206",
    "variable": "var(--colors-eds\\.palette\\.amber\\.100)"
  },
  "colors.eds.palette.amber.200": {
    "value": "#744f0e",
    "variable": "var(--colors-eds\\.palette\\.amber\\.200)"
  },
  "colors.eds.palette.amber.300": {
    "value": "#b77c17",
    "variable": "var(--colors-eds\\.palette\\.amber\\.300)"
  },
  "colors.eds.palette.amber.400": {
    "value": "#f9a91f",
    "variable": "var(--colors-eds\\.palette\\.amber\\.400)"
  },
  "colors.eds.palette.amber.500": {
    "value": "#fbc05b",
    "variable": "var(--colors-eds\\.palette\\.amber\\.500)"
  },
  "colors.eds.palette.amber.600": {
    "value": "#fcd796",
    "variable": "var(--colors-eds\\.palette\\.amber\\.600)"
  },
  "colors.eds.palette.amber.700": {
    "value": "#feeed2",
    "variable": "var(--colors-eds\\.palette\\.amber\\.700)"
  },
  "colors.eds.palette.orange.100": {
    "value": "#331b0b",
    "variable": "var(--colors-eds\\.palette\\.orange\\.100)"
  },
  "colors.eds.palette.orange.200": {
    "value": "#773e1b",
    "variable": "var(--colors-eds\\.palette\\.orange\\.200)"
  },
  "colors.eds.palette.orange.300": {
    "value": "#ba622a",
    "variable": "var(--colors-eds\\.palette\\.orange\\.300)"
  },
  "colors.eds.palette.orange.400": {
    "value": "#fe8539",
    "variable": "var(--colors-eds\\.palette\\.orange\\.400)"
  },
  "colors.eds.palette.orange.500": {
    "value": "#fea66e",
    "variable": "var(--colors-eds\\.palette\\.orange\\.500)"
  },
  "colors.eds.palette.orange.600": {
    "value": "#ffc6a3",
    "variable": "var(--colors-eds\\.palette\\.orange\\.600)"
  },
  "colors.eds.palette.orange.700": {
    "value": "#ffe7d7",
    "variable": "var(--colors-eds\\.palette\\.orange\\.700)"
  },
  "colors.eds.palette.brown.100": {
    "value": "#221a14",
    "variable": "var(--colors-eds\\.palette\\.brown\\.100)"
  },
  "colors.eds.palette.brown.200": {
    "value": "#4f3c30",
    "variable": "var(--colors-eds\\.palette\\.brown\\.200)"
  },
  "colors.eds.palette.brown.300": {
    "value": "#7c5e4b",
    "variable": "var(--colors-eds\\.palette\\.brown\\.300)"
  },
  "colors.eds.palette.brown.400": {
    "value": "#a98166",
    "variable": "var(--colors-eds\\.palette\\.brown\\.400)"
  },
  "colors.eds.palette.brown.500": {
    "value": "#c0a28f",
    "variable": "var(--colors-eds\\.palette\\.brown\\.500)"
  },
  "colors.eds.palette.brown.600": {
    "value": "#d7c4b8",
    "variable": "var(--colors-eds\\.palette\\.brown\\.600)"
  },
  "colors.eds.palette.brown.700": {
    "value": "#eee6e0",
    "variable": "var(--colors-eds\\.palette\\.brown\\.700)"
  },
  "colors.eds.text.primary": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.text\\.primary)"
  },
  "colors.eds.text.secondary": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.text\\.secondary)"
  },
  "colors.eds.text.disabled.default": {
    "value": "rgba(255, 255, 255, 0.65)",
    "variable": "var(--colors-eds\\.text\\.disabled\\.default)"
  },
  "colors.eds.text.disabled.inverted": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.text\\.disabled\\.inverted)"
  },
  "colors.eds.text.link.primary.default": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.text\\.link\\.primary\\.default)"
  },
  "colors.eds.text.link.primary.press": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.text\\.link\\.primary\\.press)"
  },
  "colors.eds.text.link.secondary.default": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.text\\.link\\.secondary\\.default)"
  },
  "colors.eds.text.link.secondary.press": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.text\\.link\\.secondary\\.press)"
  },
  "colors.eds.text.link.onAccent.default": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.text\\.link\\.on-accent\\.default)"
  },
  "colors.eds.text.link.onAccent.press": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.text\\.link\\.on-accent\\.press)"
  },
  "colors.eds.text.select.default": {
    "value": "#26bbff",
    "variable": "var(--colors-eds\\.text\\.select\\.default)"
  },
  "colors.eds.text.select.hover": {
    "value": "#61cdff",
    "variable": "var(--colors-eds\\.text\\.select\\.hover)"
  },
  "colors.eds.text.success": {
    "value": "#45c761",
    "variable": "var(--colors-eds\\.text\\.success)"
  },
  "colors.eds.text.warning": {
    "value": "#ffc229",
    "variable": "var(--colors-eds\\.text\\.warning)"
  },
  "colors.eds.text.critical": {
    "value": "#ff6173",
    "variable": "var(--colors-eds\\.text\\.critical)"
  },
  "colors.eds.text.onAccent": {
    "value": "#000000",
    "variable": "var(--colors-eds\\.text\\.on-accent)"
  },
  "colors.eds.text.contrast": {
    "value": "#ffffff",
    "variable": "var(--colors-eds\\.text\\.contrast)"
  },
  "colors.eds.opacity.highlight": {
    "value": "0.2",
    "variable": "var(--colors-eds\\.opacity\\.highlight)"
  },
  "colors.eds.opacity.disabled": {
    "value": "0.5",
    "variable": "var(--colors-eds\\.opacity\\.disabled)"
  },
  "colors.eds.opacity.loading": {
    "value": "0.8",
    "variable": "var(--colors-eds\\.opacity\\.loading)"
  },
  "colors.eds.opacity.readOnly": {
    "value": "0.8",
    "variable": "var(--colors-eds\\.opacity\\.read-only)"
  },
  "colors.eds.opacity.imageHover": {
    "value": "0.8",
    "variable": "var(--colors-eds\\.opacity\\.image-hover)"
  },
  "colors.eds.effect.material.blur": {
    "value": "blur(50px)",
    "variable": "var(--colors-eds\\.effect\\.material\\.blur)"
  },
  "colors.eds.effect.material.blur-new.25": {
    "value": "blur(12.5px)",
    "variable": "var(--colors-eds\\.effect\\.material\\.blur-new\\.25)"
  },
  "colors.eds.effect.material.blur-new.75": {
    "value": "blur(37.5px)",
    "variable": "var(--colors-eds\\.effect\\.material\\.blur-new\\.75)"
  },
  "colors.eds.effect.material.blur-new.150": {
    "value": "blur(75px)",
    "variable": "var(--colors-eds\\.effect\\.material\\.blur-new\\.150)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fonts.eds.family.base": {
    "value": "Inter, sans-serif",
    "variable": "var(--fonts-eds\\.family\\.base)"
  },
  "fonts.eds.family.display": {
    "value": "Inter Tight, sans-serif",
    "variable": "var(--fonts-eds\\.family\\.display)"
  },
  "fonts.eds.family.code": {
    "value": "Recursive Mono, sans-serif",
    "variable": "var(--fonts-eds\\.family\\.code)"
  },
  "fonts.eds.weight.regular": {
    "value": "400",
    "variable": "var(--fonts-eds\\.weight\\.regular)"
  },
  "fonts.eds.weight.medium": {
    "value": "500",
    "variable": "var(--fonts-eds\\.weight\\.medium)"
  },
  "fonts.eds.weight.bold": {
    "value": "700",
    "variable": "var(--fonts-eds\\.weight\\.bold)"
  },
  "fonts.eds.weight.black": {
    "value": "900",
    "variable": "var(--fonts-eds\\.weight\\.black)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "fontSizes.eds.font.10": {
    "value": "0.625rem",
    "variable": "var(--font-sizes-eds\\.font\\.10)"
  },
  "fontSizes.eds.font.12": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-eds\\.font\\.12)"
  },
  "fontSizes.eds.font.14": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-eds\\.font\\.14)"
  },
  "fontSizes.eds.font.16": {
    "value": "1rem",
    "variable": "var(--font-sizes-eds\\.font\\.16)"
  },
  "fontSizes.eds.font.18": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-eds\\.font\\.18)"
  },
  "fontSizes.eds.font.20": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-eds\\.font\\.20)"
  },
  "fontSizes.eds.font.24": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-eds\\.font\\.24)"
  },
  "fontSizes.eds.font.32": {
    "value": "2rem",
    "variable": "var(--font-sizes-eds\\.font\\.32)"
  },
  "fontSizes.eds.font.40": {
    "value": "2.5rem",
    "variable": "var(--font-sizes-eds\\.font\\.40)"
  },
  "fontSizes.eds.font.52": {
    "value": "3.25rem",
    "variable": "var(--font-sizes-eds\\.font\\.52)"
  },
  "fontSizes.eds.font.64": {
    "value": "4rem",
    "variable": "var(--font-sizes-eds\\.font\\.64)"
  },
  "fontSizes.eds.font.base": {
    "value": "16px",
    "variable": "var(--font-sizes-eds\\.font\\.base)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.snug": {
    "value": "1.375",
    "variable": "var(--line-heights-snug)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.625",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "lineHeights.eds.lineHeight.100": {
    "value": "100%",
    "variable": "var(--line-heights-eds\\.line-height\\.100)"
  },
  "lineHeights.eds.lineHeight.120": {
    "value": "120%",
    "variable": "var(--line-heights-eds\\.line-height\\.120)"
  },
  "lineHeights.eds.lineHeight.125": {
    "value": "125%",
    "variable": "var(--line-heights-eds\\.line-height\\.125)"
  },
  "lineHeights.eds.lineHeight.130": {
    "value": "130%",
    "variable": "var(--line-heights-eds\\.line-height\\.130)"
  },
  "lineHeights.eds.lineHeight.140": {
    "value": "140%",
    "variable": "var(--line-heights-eds\\.line-height\\.140)"
  },
  "lineHeights.eds.lineHeight.145": {
    "value": "145%",
    "variable": "var(--line-heights-eds\\.line-height\\.145)"
  },
  "lineHeights.eds.lineHeight.150": {
    "value": "150%",
    "variable": "var(--line-heights-eds\\.line-height\\.150)"
  },
  "lineHeights.eds.lineHeight.165": {
    "value": "165%",
    "variable": "var(--line-heights-eds\\.line-height\\.165)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--radii-4xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "radii.eds.dimension.1": {
    "value": "0.0625rem",
    "variable": "var(--radii-eds\\.dimension\\.1)"
  },
  "radii.eds.dimension.2": {
    "value": "0.125rem",
    "variable": "var(--radii-eds\\.dimension\\.2)"
  },
  "radii.eds.dimension.3": {
    "value": "0.1875rem",
    "variable": "var(--radii-eds\\.dimension\\.3)"
  },
  "radii.eds.dimension.4": {
    "value": "0.25rem",
    "variable": "var(--radii-eds\\.dimension\\.4)"
  },
  "radii.eds.dimension.6": {
    "value": "0.375rem",
    "variable": "var(--radii-eds\\.dimension\\.6)"
  },
  "radii.eds.dimension.8": {
    "value": "0.5rem",
    "variable": "var(--radii-eds\\.dimension\\.8)"
  },
  "radii.eds.dimension.10": {
    "value": "0.625rem",
    "variable": "var(--radii-eds\\.dimension\\.10)"
  },
  "radii.eds.dimension.12": {
    "value": "0.75rem",
    "variable": "var(--radii-eds\\.dimension\\.12)"
  },
  "radii.eds.dimension.14": {
    "value": "0.875rem",
    "variable": "var(--radii-eds\\.dimension\\.14)"
  },
  "radii.eds.dimension.16": {
    "value": "1rem",
    "variable": "var(--radii-eds\\.dimension\\.16)"
  },
  "radii.eds.dimension.18": {
    "value": "1.125rem",
    "variable": "var(--radii-eds\\.dimension\\.18)"
  },
  "radii.eds.dimension.20": {
    "value": "1.25rem",
    "variable": "var(--radii-eds\\.dimension\\.20)"
  },
  "radii.eds.dimension.24": {
    "value": "1.5rem",
    "variable": "var(--radii-eds\\.dimension\\.24)"
  },
  "radii.eds.dimension.28": {
    "value": "1.75rem",
    "variable": "var(--radii-eds\\.dimension\\.28)"
  },
  "radii.eds.dimension.32": {
    "value": "2rem",
    "variable": "var(--radii-eds\\.dimension\\.32)"
  },
  "radii.eds.dimension.40": {
    "value": "2.5rem",
    "variable": "var(--radii-eds\\.dimension\\.40)"
  },
  "radii.eds.dimension.48": {
    "value": "3rem",
    "variable": "var(--radii-eds\\.dimension\\.48)"
  },
  "radii.eds.dimension.56": {
    "value": "3.5rem",
    "variable": "var(--radii-eds\\.dimension\\.56)"
  },
  "radii.eds.dimension.64": {
    "value": "4rem",
    "variable": "var(--radii-eds\\.dimension\\.64)"
  },
  "radii.eds.dimension.72": {
    "value": "4.5rem",
    "variable": "var(--radii-eds\\.dimension\\.72)"
  },
  "radii.eds.dimension.76": {
    "value": "4.75rem",
    "variable": "var(--radii-eds\\.dimension\\.76)"
  },
  "radii.eds.dimension.80": {
    "value": "5rem",
    "variable": "var(--radii-eds\\.dimension\\.80)"
  },
  "radii.eds.dimension.96": {
    "value": "6rem",
    "variable": "var(--radii-eds\\.dimension\\.96)"
  },
  "radii.eds.dimension.128": {
    "value": "8rem",
    "variable": "var(--radii-eds\\.dimension\\.128)"
  },
  "radii.eds.dimension.160": {
    "value": "10rem",
    "variable": "var(--radii-eds\\.dimension\\.160)"
  },
  "radii.cosmos.article.sm": {
    "value": "824px",
    "variable": "var(--radii-cosmos\\.article\\.sm)"
  },
  "radii.cosmos.article.md": {
    "value": "1200px",
    "variable": "var(--radii-cosmos\\.article\\.md)"
  },
  "radii.cosmos.article.lg": {
    "value": "1920px",
    "variable": "var(--radii-cosmos\\.article\\.lg)"
  },
  "radii.eds.borderRadius.2": {
    "value": "2px",
    "variable": "var(--radii-eds\\.border-radius\\.2)"
  },
  "radii.eds.borderRadius.3": {
    "value": "3px",
    "variable": "var(--radii-eds\\.border-radius\\.3)"
  },
  "radii.eds.borderRadius.4": {
    "value": "4px",
    "variable": "var(--radii-eds\\.border-radius\\.4)"
  },
  "radii.eds.borderRadius.5": {
    "value": "5px",
    "variable": "var(--radii-eds\\.border-radius\\.5)"
  },
  "radii.eds.borderRadius.6": {
    "value": "6px",
    "variable": "var(--radii-eds\\.border-radius\\.6)"
  },
  "radii.eds.borderRadius.7": {
    "value": "7px",
    "variable": "var(--radii-eds\\.border-radius\\.7)"
  },
  "radii.eds.borderRadius.8": {
    "value": "8px",
    "variable": "var(--radii-eds\\.border-radius\\.8)"
  },
  "radii.eds.borderRadius.9": {
    "value": "9px",
    "variable": "var(--radii-eds\\.border-radius\\.9)"
  },
  "radii.eds.borderRadius.10": {
    "value": "10px",
    "variable": "var(--radii-eds\\.border-radius\\.10)"
  },
  "radii.eds.borderRadius.11": {
    "value": "11px",
    "variable": "var(--radii-eds\\.border-radius\\.11)"
  },
  "radii.eds.borderRadius.12": {
    "value": "12px",
    "variable": "var(--radii-eds\\.border-radius\\.12)"
  },
  "radii.eds.borderRadius.13": {
    "value": "13px",
    "variable": "var(--radii-eds\\.border-radius\\.13)"
  },
  "radii.eds.borderRadius.14": {
    "value": "14px",
    "variable": "var(--radii-eds\\.border-radius\\.14)"
  },
  "radii.eds.borderRadius.15": {
    "value": "15px",
    "variable": "var(--radii-eds\\.border-radius\\.15)"
  },
  "radii.eds.borderRadius.16": {
    "value": "16px",
    "variable": "var(--radii-eds\\.border-radius\\.16)"
  },
  "radii.eds.borderRadius.24": {
    "value": "24px",
    "variable": "var(--radii-eds\\.border-radius\\.24)"
  },
  "radii.eds.borderRadius.28": {
    "value": "28px",
    "variable": "var(--radii-eds\\.border-radius\\.28)"
  },
  "radii.eds.borderRadius.32": {
    "value": "32px",
    "variable": "var(--radii-eds\\.border-radius\\.32)"
  },
  "radii.eds.borderRadius.full": {
    "value": "9999px",
    "variable": "var(--radii-eds\\.border-radius\\.full)"
  },
  "shadows.xs": {
    "value": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    "variable": "var(--shadows-2xl)"
  },
  "shadows.inner": {
    "value": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inner)"
  },
  "shadows.eds.bottom.sm": {
    "value": "0 1px 1px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.1), 0 4px 4px rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.bottom\\.sm)"
  },
  "shadows.eds.bottom.md": {
    "value": "0 2px 1px rgba(0, 0, 0, 0.1), 0 4px 2px rgba(0, 0, 0, 0.1), 0 8px 4px rgba(0, 0, 0, 0.1), 0 16px 8px rgba(0, 0, 0, 0.1), 0 32px 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.bottom\\.md)"
  },
  "shadows.eds.top.sm": {
    "value": "0 -1px 1px rgba(0, 0, 0, 0.1), 0 -2px 2px rgba(0, 0, 0, 0.1), 0 -4px 4px rgba(0, 0, 0, 0.1), 0 -6px 8px rgba(0, 0, 0, 0.1), 0 -8px 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.top\\.sm)"
  },
  "shadows.eds.top.md": {
    "value": "0 -2px 1px rgba(0, 0, 0, 0.1), 0 -4px 2px rgba(0, 0, 0, 0.1), 0 -8px 4px rgba(0, 0, 0, 0.1), 0 -16px 8px rgba(0, 0, 0, 0.1), 0 -32px 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.top\\.md)"
  },
  "shadows.eds.left.sm": {
    "value": "-1px 0 1px rgba(0, 0, 0, 0.1), -2px 0 2px rgba(0, 0, 0, 0.1), -4px 0 4px rgba(0, 0, 0, 0.1), -6px 0 8px rgba(0, 0, 0, 0.1), -8px 0 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.left\\.sm)"
  },
  "shadows.eds.left.md": {
    "value": "-2px 0 1px rgba(0, 0, 0, 0.1), -4px 0 2px rgba(0, 0, 0, 0.1), -8px 0 4px rgba(0, 0, 0, 0.1), -16px 0 8px rgba(0, 0, 0, 0.1), -32px 0 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.left\\.md)"
  },
  "shadows.eds.right.sm": {
    "value": "1px 0 1px rgba(0, 0, 0, 0.1), 2px 0 2px rgba(0, 0, 0, 0.1), 4px 0 4px rgba(0, 0, 0, 0.1), 6px 0 8px rgba(0, 0, 0, 0.1), 8px 0 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.right\\.sm)"
  },
  "shadows.eds.right.md": {
    "value": "2px 0 1px rgba(0, 0, 0, 0.1), 4px 0 2px rgba(0, 0, 0, 0.1), 8px 0 4px rgba(0, 0, 0, 0.1), 16px 0 8px rgba(0, 0, 0, 0.1), 32px 0 16px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-eds\\.right\\.md)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--sizes-prose)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.eds.dimension.1": {
    "value": "0.0625rem",
    "variable": "var(--sizes-eds\\.dimension\\.1)"
  },
  "sizes.eds.dimension.2": {
    "value": "0.125rem",
    "variable": "var(--sizes-eds\\.dimension\\.2)"
  },
  "sizes.eds.dimension.3": {
    "value": "0.1875rem",
    "variable": "var(--sizes-eds\\.dimension\\.3)"
  },
  "sizes.eds.dimension.4": {
    "value": "0.25rem",
    "variable": "var(--sizes-eds\\.dimension\\.4)"
  },
  "sizes.eds.dimension.6": {
    "value": "0.375rem",
    "variable": "var(--sizes-eds\\.dimension\\.6)"
  },
  "sizes.eds.dimension.8": {
    "value": "0.5rem",
    "variable": "var(--sizes-eds\\.dimension\\.8)"
  },
  "sizes.eds.dimension.10": {
    "value": "0.625rem",
    "variable": "var(--sizes-eds\\.dimension\\.10)"
  },
  "sizes.eds.dimension.12": {
    "value": "0.75rem",
    "variable": "var(--sizes-eds\\.dimension\\.12)"
  },
  "sizes.eds.dimension.14": {
    "value": "0.875rem",
    "variable": "var(--sizes-eds\\.dimension\\.14)"
  },
  "sizes.eds.dimension.16": {
    "value": "1rem",
    "variable": "var(--sizes-eds\\.dimension\\.16)"
  },
  "sizes.eds.dimension.18": {
    "value": "1.125rem",
    "variable": "var(--sizes-eds\\.dimension\\.18)"
  },
  "sizes.eds.dimension.20": {
    "value": "1.25rem",
    "variable": "var(--sizes-eds\\.dimension\\.20)"
  },
  "sizes.eds.dimension.24": {
    "value": "1.5rem",
    "variable": "var(--sizes-eds\\.dimension\\.24)"
  },
  "sizes.eds.dimension.28": {
    "value": "1.75rem",
    "variable": "var(--sizes-eds\\.dimension\\.28)"
  },
  "sizes.eds.dimension.32": {
    "value": "2rem",
    "variable": "var(--sizes-eds\\.dimension\\.32)"
  },
  "sizes.eds.dimension.40": {
    "value": "2.5rem",
    "variable": "var(--sizes-eds\\.dimension\\.40)"
  },
  "sizes.eds.dimension.48": {
    "value": "3rem",
    "variable": "var(--sizes-eds\\.dimension\\.48)"
  },
  "sizes.eds.dimension.56": {
    "value": "3.5rem",
    "variable": "var(--sizes-eds\\.dimension\\.56)"
  },
  "sizes.eds.dimension.64": {
    "value": "4rem",
    "variable": "var(--sizes-eds\\.dimension\\.64)"
  },
  "sizes.eds.dimension.72": {
    "value": "4.5rem",
    "variable": "var(--sizes-eds\\.dimension\\.72)"
  },
  "sizes.eds.dimension.76": {
    "value": "4.75rem",
    "variable": "var(--sizes-eds\\.dimension\\.76)"
  },
  "sizes.eds.dimension.80": {
    "value": "5rem",
    "variable": "var(--sizes-eds\\.dimension\\.80)"
  },
  "sizes.eds.dimension.96": {
    "value": "6rem",
    "variable": "var(--sizes-eds\\.dimension\\.96)"
  },
  "sizes.eds.dimension.128": {
    "value": "8rem",
    "variable": "var(--sizes-eds\\.dimension\\.128)"
  },
  "sizes.eds.dimension.160": {
    "value": "10rem",
    "variable": "var(--sizes-eds\\.dimension\\.160)"
  },
  "sizes.cosmos.article.sm": {
    "value": "824px",
    "variable": "var(--sizes-cosmos\\.article\\.sm)"
  },
  "sizes.cosmos.article.md": {
    "value": "1200px",
    "variable": "var(--sizes-cosmos\\.article\\.md)"
  },
  "sizes.cosmos.article.lg": {
    "value": "1920px",
    "variable": "var(--sizes-cosmos\\.article\\.lg)"
  },
  "sizes.eds.borderWidth.1": {
    "value": "1px",
    "variable": "var(--sizes-eds\\.border-width\\.1)"
  },
  "sizes.eds.borderWidth.2": {
    "value": "2px",
    "variable": "var(--sizes-eds\\.border-width\\.2)"
  },
  "sizes.eds.borderWidth.focus": {
    "value": "2px",
    "variable": "var(--sizes-eds\\.border-width\\.focus)"
  },
  "sizes.eds.borderWidth.ui.sm": {
    "value": "1px",
    "variable": "var(--sizes-eds\\.border-width\\.ui\\.sm)"
  },
  "sizes.eds.borderWidth.ui.md": {
    "value": "2px",
    "variable": "var(--sizes-eds\\.border-width\\.ui\\.md)"
  },
  "sizes.breakpoint-xxs": {
    "value": "0px",
    "variable": "var(--sizes-breakpoint-xxs)"
  },
  "sizes.breakpoint-xs": {
    "value": "375px",
    "variable": "var(--sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1440px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-xxl": {
    "value": "1920px",
    "variable": "var(--sizes-breakpoint-xxl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1920px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.eds.dimension.1": {
    "value": "0.0625rem",
    "variable": "var(--spacing-eds\\.dimension\\.1)"
  },
  "spacing.eds.dimension.2": {
    "value": "0.125rem",
    "variable": "var(--spacing-eds\\.dimension\\.2)"
  },
  "spacing.eds.dimension.3": {
    "value": "0.1875rem",
    "variable": "var(--spacing-eds\\.dimension\\.3)"
  },
  "spacing.eds.dimension.4": {
    "value": "0.25rem",
    "variable": "var(--spacing-eds\\.dimension\\.4)"
  },
  "spacing.eds.dimension.6": {
    "value": "0.375rem",
    "variable": "var(--spacing-eds\\.dimension\\.6)"
  },
  "spacing.eds.dimension.8": {
    "value": "0.5rem",
    "variable": "var(--spacing-eds\\.dimension\\.8)"
  },
  "spacing.eds.dimension.10": {
    "value": "0.625rem",
    "variable": "var(--spacing-eds\\.dimension\\.10)"
  },
  "spacing.eds.dimension.12": {
    "value": "0.75rem",
    "variable": "var(--spacing-eds\\.dimension\\.12)"
  },
  "spacing.eds.dimension.14": {
    "value": "0.875rem",
    "variable": "var(--spacing-eds\\.dimension\\.14)"
  },
  "spacing.eds.dimension.16": {
    "value": "1rem",
    "variable": "var(--spacing-eds\\.dimension\\.16)"
  },
  "spacing.eds.dimension.18": {
    "value": "1.125rem",
    "variable": "var(--spacing-eds\\.dimension\\.18)"
  },
  "spacing.eds.dimension.20": {
    "value": "1.25rem",
    "variable": "var(--spacing-eds\\.dimension\\.20)"
  },
  "spacing.eds.dimension.24": {
    "value": "1.5rem",
    "variable": "var(--spacing-eds\\.dimension\\.24)"
  },
  "spacing.eds.dimension.28": {
    "value": "1.75rem",
    "variable": "var(--spacing-eds\\.dimension\\.28)"
  },
  "spacing.eds.dimension.32": {
    "value": "2rem",
    "variable": "var(--spacing-eds\\.dimension\\.32)"
  },
  "spacing.eds.dimension.40": {
    "value": "2.5rem",
    "variable": "var(--spacing-eds\\.dimension\\.40)"
  },
  "spacing.eds.dimension.48": {
    "value": "3rem",
    "variable": "var(--spacing-eds\\.dimension\\.48)"
  },
  "spacing.eds.dimension.56": {
    "value": "3.5rem",
    "variable": "var(--spacing-eds\\.dimension\\.56)"
  },
  "spacing.eds.dimension.64": {
    "value": "4rem",
    "variable": "var(--spacing-eds\\.dimension\\.64)"
  },
  "spacing.eds.dimension.72": {
    "value": "4.5rem",
    "variable": "var(--spacing-eds\\.dimension\\.72)"
  },
  "spacing.eds.dimension.76": {
    "value": "4.75rem",
    "variable": "var(--spacing-eds\\.dimension\\.76)"
  },
  "spacing.eds.dimension.80": {
    "value": "5rem",
    "variable": "var(--spacing-eds\\.dimension\\.80)"
  },
  "spacing.eds.dimension.96": {
    "value": "6rem",
    "variable": "var(--spacing-eds\\.dimension\\.96)"
  },
  "spacing.eds.dimension.128": {
    "value": "8rem",
    "variable": "var(--spacing-eds\\.dimension\\.128)"
  },
  "spacing.eds.dimension.160": {
    "value": "10rem",
    "variable": "var(--spacing-eds\\.dimension\\.160)"
  },
  "spacing.cosmos.article.sm": {
    "value": "824px",
    "variable": "var(--spacing-cosmos\\.article\\.sm)"
  },
  "spacing.cosmos.article.md": {
    "value": "1200px",
    "variable": "var(--spacing-cosmos\\.article\\.md)"
  },
  "spacing.cosmos.article.lg": {
    "value": "1920px",
    "variable": "var(--spacing-cosmos\\.article\\.lg)"
  },
  "spacing.eds.letterSpacing.0": {
    "value": "0em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.0)"
  },
  "spacing.eds.letterSpacing.001": {
    "value": "0.01em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.001)"
  },
  "spacing.eds.letterSpacing.002": {
    "value": "0.02em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.002)"
  },
  "spacing.eds.letterSpacing.003": {
    "value": "0.03em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.003)"
  },
  "spacing.eds.letterSpacing.004": {
    "value": "0.04em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.004)"
  },
  "spacing.eds.letterSpacing.010": {
    "value": "0.1em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.010)"
  },
  "spacing.eds.letterSpacing.negative001": {
    "value": "-0.01em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative001)"
  },
  "spacing.eds.letterSpacing.negative002": {
    "value": "-0.02em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative002)"
  },
  "spacing.eds.letterSpacing.negative0035": {
    "value": "-0.035em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0035)"
  },
  "spacing.eds.letterSpacing.negative0025": {
    "value": "-0.025em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0025)"
  },
  "spacing.eds.letterSpacing.negative0015": {
    "value": "-0.015em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0015)"
  },
  "spacing.eds.letterSpacing.negative0005": {
    "value": "-0.005em",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0005)"
  },
  "gradients.eds.gradient.amber": {
    "value": "linear-gradient(225deg, #d7f4b0 0%, #f9a91f 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.amber)"
  },
  "gradients.eds.gradient.blue": {
    "value": "linear-gradient(225deg, #dfbaf8 0%, #33bfff 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.blue)"
  },
  "gradients.eds.gradient.cyan": {
    "value": "linear-gradient(225deg, #c7c8fe 0%, #44d5bf 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.cyan)"
  },
  "gradients.eds.gradient.green": {
    "value": "linear-gradient(225deg, #a0e1ff 0%, #5fe367 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.green)"
  },
  "gradients.eds.gradient.indigo": {
    "value": "linear-gradient(225deg, #f1b8dd 0%, #868afd 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.indigo)"
  },
  "gradients.eds.gradient.lime": {
    "value": "linear-gradient(225deg, #a8ebe1 0%, #aae755 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.lime)"
  },
  "gradients.eds.gradient.orange": {
    "value": "linear-gradient(225deg, #fbed9c 0%, #fe8539 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.orange)"
  },
  "gradients.eds.gradient.pink": {
    "value": "linear-gradient(225deg, #ffc6a3 0%, #e166b6 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.pink)"
  },
  "gradients.eds.gradient.purple": {
    "value": "linear-gradient(225deg, #feb4b4 0%, #bb6bf0 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.purple)"
  },
  "gradients.eds.gradient.red": {
    "value": "linear-gradient(225deg, #fcd796 0%, #fd5e5e 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.red)"
  },
  "gradients.eds.gradient.yellow": {
    "value": "linear-gradient(225deg, #b4f2b8 0%, #f7d82b 100%)",
    "variable": "var(--gradients-eds\\.gradient\\.yellow)"
  },
  "breakpoints.xxs": {
    "value": "0px",
    "variable": "var(--breakpoints-xxs)"
  },
  "breakpoints.xs": {
    "value": "375px",
    "variable": "var(--breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "768px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "1024px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1280px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1440px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.xxl": {
    "value": "1920px",
    "variable": "var(--breakpoints-xxl)"
  },
  "breakpoints.2xl": {
    "value": "1920px",
    "variable": "var(--breakpoints-2xl)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-eds.dimension.1": {
    "value": "calc(var(--spacing-eds\\.dimension\\.1) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.1)"
  },
  "spacing.-eds.dimension.2": {
    "value": "calc(var(--spacing-eds\\.dimension\\.2) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.2)"
  },
  "spacing.-eds.dimension.3": {
    "value": "calc(var(--spacing-eds\\.dimension\\.3) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.3)"
  },
  "spacing.-eds.dimension.4": {
    "value": "calc(var(--spacing-eds\\.dimension\\.4) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.4)"
  },
  "spacing.-eds.dimension.6": {
    "value": "calc(var(--spacing-eds\\.dimension\\.6) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.6)"
  },
  "spacing.-eds.dimension.8": {
    "value": "calc(var(--spacing-eds\\.dimension\\.8) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.8)"
  },
  "spacing.-eds.dimension.10": {
    "value": "calc(var(--spacing-eds\\.dimension\\.10) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.10)"
  },
  "spacing.-eds.dimension.12": {
    "value": "calc(var(--spacing-eds\\.dimension\\.12) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.12)"
  },
  "spacing.-eds.dimension.14": {
    "value": "calc(var(--spacing-eds\\.dimension\\.14) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.14)"
  },
  "spacing.-eds.dimension.16": {
    "value": "calc(var(--spacing-eds\\.dimension\\.16) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.16)"
  },
  "spacing.-eds.dimension.18": {
    "value": "calc(var(--spacing-eds\\.dimension\\.18) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.18)"
  },
  "spacing.-eds.dimension.20": {
    "value": "calc(var(--spacing-eds\\.dimension\\.20) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.20)"
  },
  "spacing.-eds.dimension.24": {
    "value": "calc(var(--spacing-eds\\.dimension\\.24) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.24)"
  },
  "spacing.-eds.dimension.28": {
    "value": "calc(var(--spacing-eds\\.dimension\\.28) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.28)"
  },
  "spacing.-eds.dimension.32": {
    "value": "calc(var(--spacing-eds\\.dimension\\.32) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.32)"
  },
  "spacing.-eds.dimension.40": {
    "value": "calc(var(--spacing-eds\\.dimension\\.40) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.40)"
  },
  "spacing.-eds.dimension.48": {
    "value": "calc(var(--spacing-eds\\.dimension\\.48) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.48)"
  },
  "spacing.-eds.dimension.56": {
    "value": "calc(var(--spacing-eds\\.dimension\\.56) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.56)"
  },
  "spacing.-eds.dimension.64": {
    "value": "calc(var(--spacing-eds\\.dimension\\.64) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.64)"
  },
  "spacing.-eds.dimension.72": {
    "value": "calc(var(--spacing-eds\\.dimension\\.72) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.72)"
  },
  "spacing.-eds.dimension.76": {
    "value": "calc(var(--spacing-eds\\.dimension\\.76) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.76)"
  },
  "spacing.-eds.dimension.80": {
    "value": "calc(var(--spacing-eds\\.dimension\\.80) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.80)"
  },
  "spacing.-eds.dimension.96": {
    "value": "calc(var(--spacing-eds\\.dimension\\.96) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.96)"
  },
  "spacing.-eds.dimension.128": {
    "value": "calc(var(--spacing-eds\\.dimension\\.128) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.128)"
  },
  "spacing.-eds.dimension.160": {
    "value": "calc(var(--spacing-eds\\.dimension\\.160) * -1)",
    "variable": "var(--spacing-eds\\.dimension\\.160)"
  },
  "spacing.-cosmos.article.sm": {
    "value": "calc(var(--spacing-cosmos\\.article\\.sm) * -1)",
    "variable": "var(--spacing-cosmos\\.article\\.sm)"
  },
  "spacing.-cosmos.article.md": {
    "value": "calc(var(--spacing-cosmos\\.article\\.md) * -1)",
    "variable": "var(--spacing-cosmos\\.article\\.md)"
  },
  "spacing.-cosmos.article.lg": {
    "value": "calc(var(--spacing-cosmos\\.article\\.lg) * -1)",
    "variable": "var(--spacing-cosmos\\.article\\.lg)"
  },
  "spacing.-eds.letterSpacing.0": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.0) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.0)"
  },
  "spacing.-eds.letterSpacing.001": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.001) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.001)"
  },
  "spacing.-eds.letterSpacing.002": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.002) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.002)"
  },
  "spacing.-eds.letterSpacing.003": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.003) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.003)"
  },
  "spacing.-eds.letterSpacing.004": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.004) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.004)"
  },
  "spacing.-eds.letterSpacing.010": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.010) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.010)"
  },
  "spacing.-eds.letterSpacing.negative001": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative001) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative001)"
  },
  "spacing.-eds.letterSpacing.negative002": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative002) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative002)"
  },
  "spacing.-eds.letterSpacing.negative0035": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative0035) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0035)"
  },
  "spacing.-eds.letterSpacing.negative0025": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative0025) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0025)"
  },
  "spacing.-eds.letterSpacing.negative0015": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative0015) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0015)"
  },
  "spacing.-eds.letterSpacing.negative0005": {
    "value": "calc(var(--spacing-eds\\.letter-spacing\\.negative0005) * -1)",
    "variable": "var(--spacing-eds\\.letter-spacing\\.negative0005)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar